<template>
    <article class="page page-directors-single">
        <section 
            v-if="director"
            :class="['page-directors-single-biography', {show: biographyIsOpen}]"
        >
            <div class="page-directors-single-biography-titles">
                <h2 class="page-directors-single-biography-titles-name">{{ director.name }}</h2>
                <h2 class="page-directors-single-biography-titles-label">Biography</h2>
            </div>
            <button @click="() => toggleBiography(false)" class="page-directors-single-biography-close">
                <icon-cross/>
            </button>
            <div class="page-directors-single-biography-body">
                <h1 class="page-directors-single-biography-body-name">{{ director.name }}</h1>
                <h6 class="page-directors-single-biography-body-sub">{{ director.biography_subtitle }}</h6>
                <p class="page-directors-single-biography-body-text">{{ director.biography_text }}</p>
            </div>
        </section>
        <header 
            v-if="director" 
            v-show="!biographyIsOpen"
            class="page-directors-single-header"
        >
            <h1 class="page-directors-single-header-director">{{ director.name }}</h1>
            <button @click="toggleBiography" :class="['page-directors-single-header-biography-btn']">Biography</button>
            <button @click="() => $router.push({name: $route.name === 'directors-single' ? 'directors' : 'home'})" class="page-directors-single-header-goback">Close</button>
        </header>

        <!-- Scene3d or list -->
        <WorkListMobile v-if="director && $root.mobileDetected" :works="director.imgs"/>
        <WorkListDesktop v-if="!$root.mobileDetected && director" :works="director.imgs"/>

    </article>
</template>

<script>

// Libs
import gsap from "gsap"

// Data
import {directors as __directors} from '../../__data'

// Component 
import WorkListMobile from '../shared/WorkListMobile'
import WorkListDesktop from '../shared/WorkListDesktop'
import IconCross from '../icons/icon-cross'

// Utils
import Utils from '../../utils/utils'
import params from '../../utils/params'
import MyEmitter from '../../helpers/MyEmitter'

export default {
    components: {
        WorkListDesktop,
        WorkListMobile,
        "icon-cross": IconCross
    },
    data: function(){
        return {
            director: null,
            biographyIsOpen: false,
            isPrivatePage: false,
        }
    },
    name: "PageDirectorsSingle",
    beforeRouteLeave(to, from, next){
        gsap.to(this.$el, {
            duration: .4,
            onComplete: () => {
                document.title = this.previousDocumentTitle
                next()
            },
            opacity: 0
        })
    },
    mounted: function(){
        
        const slug = this.$route.params.slug

        let routeName = this.$route.name
        
        if(routeName === "private-pages-details"){
            this.isPrivatePage = true
        }

        let directorsListRoutes = routeName === "directors-single" ? "/director/" : "/private-page/"

        Utils.fetch(directorsListRoutes + slug).then(res => {


            if(typeof res === "object" && Object.keys(res).length){

                // set document title

                this.previousDocumentTitle = document.title
                document.title = res.pageTitle

                let directorName = res.title

                if(!directorName){
                    console.warn("director do not have directorName")
                    directorName = ""
                }

                this.director = {
                    name: directorName, 
                    biography_text: res.bio, 
                    biography_subtitle: res.subtitle, 
                    imgs: res.films.map((film, filmIndex) => {


                        let slug = film.slug
                        let secondary = routeName === "private-pages-details" ? film.title : film.film_title
                        let primary = routeName === "private-pages-details" ? film.director : film.title

                        if(!slug){
                            console.warn("film " + filmIndex + " do not have slug")
                            slug = ""
                        }

                        if(!secondary){
                            console.warn("film " + filmIndex + " do not have secondary")
                            secondary = ""
                        }

                        if(!primary){
                            console.warn("film " + filmIndex + " do not have primary")
                            primary = ""
                        }

                        return {
                            id: filmIndex,
                            src: film.image,
                            primary,
                            secondary,
                            text_is_dark: false,
                            slug,

                            // src: __directors[0].imgs[Math.floor(Math.random() * __directors[0].imgs.length)].src
                        }
                    })
                }

                Utils.waitForRessourcesImages(this.director.imgs.map(w => w.src))

            } else {
                this.$router.push("/directors")
            }

        })

        // after fetch
        // setTimeout(() => {
        //     this.director = __directors.find(d => d.id === id)
        // }, 300)
    },
        methods: {
        toggleBiography: function(force = null){

            let nextState = force !== null ? force : !this.biographyIsOpen
            this.biographyIsOpen = nextState

            document.body.classList[nextState ? "add" : "remove"]("modal-is-open")

        },

        workListGoBack: function(){
            this.$router.push("/directors")
        },
    },
}
</script>

<style lang="scss">
    .page-directors-single{

        $margin-from-top: 61px;
        $margin-horizontal-desktop: 60px;
        
        overflow-y: auto;

        &-header{
            @include fixed-top();
            padding: 0 33px;
            padding-top: 33px;
            z-index: 2;
            color: $black;
            @include typo-text-mobile;

            @include desktop{
                color: #fff;
                @include typo-text-desktop;
                padding-top: $margin-from-top;
                padding-left: $margin-horizontal-desktop;
            }

            @include very-small{
                font-size: ptToPx(12);
                padding: 0 22px;
                padding-top: 22px;
            }

            &-director{
                font-weight: 700;
                margin-bottom: 18px;
                color: #fff;

                @include desktop{
                    margin-bottom: 10px;
                }

                @include very-small{
                    margin-bottom: 8px; // related to buography title margin
                }
            }

            &-biography-btn{
                font-weight: 200;
                padding: 0;
                color: #fff;


                &.hide{
                    opacity: 0;
                    visibility: hidden;
                }
                
                @include typo-text-mobile;

                @include desktop{
                    @include typo-text-desktop;
                    @include hover-text-weight;
                }

                @include very-small{
                    font-size: ptToPx(12);
                }
            }

            &-goback{
                @include float-right();
                @include typo-text-mobile;
                margin-right: 33px;
                margin-top: 33px;
                padding: 0;
                color: #fff;


                @include desktop{
                    @include typo-text-desktop;
                    @include hover-text-weight;
                    margin-right: $margin-horizontal-desktop;
                    margin-top: $margin-from-top;
                }

                @include very-small{
                    font-size: ptToPx(12);
                    margin-right: 22px;
                    margin-top: 22px;
                }
            }           
        }

        &-biography{
            @include absolute-fullscreen();
            position: fixed;
            z-index: 10;
            background-color: rgba(0, 0, 0, .9);
            opacity: 0;
            visibility: hidden;
            transition: ease 150ms;
            transition-property: opacity, visibility;

            &.show{
                opacity: 1;
                visibility: visible;
            }

            &-titles{
                position: absolute;
                left: 33px;
                top: 33px;

                @include very-small{
                    left: 22px;
                    top: 22px;
                }

                &-name, &-label{
                    @include typo-text-mobile;
                    font-weight: 700;

                    @include desktop{
                        font-size: ptToPx(11)
                    }

                    @include very-small{
                        font-size: ptToPx(12);
                    }
                }

                &-name{
                    margin-bottom: 18px;

                    @include desktop{
                        margin-bottom: 10px;
                    }

                    @include very-small{
                        margin-bottom: 10px; // related to page margin
                    }
                }

                @include desktop{
                    top: $margin-from-top;
                    left: $margin-horizontal-desktop
                }
            }

            &-close{
                @include float-right();
                right: 22px;
                top: 22px;
                transition: opacity ease 150ms;
                padding: 0;

                @include desktop{
                    top: $margin-from-top;
                    right: $margin-horizontal-desktop;

                    &:hover{
                        opacity: .5
                    }
                }

                @include very-small{
                    .icon__cross{
                        width: 20px;
                        height: 20px;
                    }
                }
            }

            &-body{
                padding: 0 33px;
                padding-top: 26vh;
                height: 100%;
                overflow-y: auto;
                padding-bottom: 35px;

                @include desktop{
                    padding-left: 24.3%;
                    padding-top: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                &-name{
                    font-family: $font-title;
                    font-size: ptToPx(32);
                    font-weight: 700;
                    margin-bottom: 10px;
                    text-transform: uppercase;

                    @include desktop{
                        font-size: ptToPx(35);
                    }

                    @include desktop-reference{
                        font-size: 2.5vw;
                    }

                    @include very-small{
                        font-size: ptToPx(20);
                        margin-bottom: 4px;
                    }
                }

                &-sub{
                    letter-spacing: 4px;
                    text-transform: uppercase;
                    line-height: ptToPx(20);
                    font-size: ptToPx(18);
                    font-weight: 400;
                    margin-bottom: 53px;

                    @include desktop{
                        font-size: ptToPx(13);
                        line-height: ptToPx(17);
                        font-weight: 700;
                        max-width: ptToPx(280);
                        letter-spacing: 0;
                    }

                    @include desktop-reference{
                        font-size: 1vw;
                        line-height: 1.15;
                        max-width: 19vw;
                    }

                    @include very-small{
                        font-size: ptToPx(11);
                        line-height: 1.4;
                        margin-bottom: 33px;
                        letter-spacing: 2px;
                    }
                }

                &-text{
                    font-size: ptToPx(24);
                    line-height: ptToPx(34);
                    white-space: pre-wrap;

                    @include desktop{
                        font-size: ptToPx(11);
                        line-height: ptToPx(15);
                        max-width: ptToPx(377);
                        text-align: justify;
                        text-align-last: left;
                    }

                    @include desktop-reference{
                        font-size: .9vw;
                        line-height: 1.4;
                        max-width: 29vw;
                    }

                    @include very-small{
                        font-size: ptToPx(14);
                        line-height: 1.4;
                    }
                }
            }
        }
    }
</style>